// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_4g-0";